import moment from "moment";

import { searchActions as A } from "./reducer";
import DashboardApi from "../../api/DashboardApi";
import { _setTickets, _setStats, connectLiveTickets, disconnectLiveTickets, _updateHighlighted, _setChart } from "../tickets/actions";
import { timers } from "../../config";
import Axios from 'axios';

// timer to handle time between executing search after user stops typing
let userInpTimerId = null;

/** Actions */
export const search = (options = { resetPage: false }) => async (dispatch, getState) => {
  dispatch(_loadingSearch(true));
  if(options.resetPage) {
    dispatch(_setPage(1));
    dispatch(_updateHighlighted({ highlighted_tickets: [] }))
  }
  const searchStore = getState().search;
  const searchOptions = searchStore.searchOptions;
  const paginationOptions = searchStore.paginationOptions;

  const { date, variable, status } = searchOptions;
  const sameEndDate = moment(date.to).isSame(moment(), 'day');

  // disable live tickets if we're searching for specific criteria
  if (variable || status || !sameEndDate) {
    dispatch(disconnectLiveTickets());
  } else {
    dispatch(connectLiveTickets());
  }

  try {
    const result = await DashboardApi.search(searchOptions, paginationOptions);
	  console.log('SearchResult >>> ', result)
    if (result.success) {
      // set tickets
      dispatch(
        _setTickets({
          tickets: result.data.v3_tickets,
          highlighted_tickets: [],
          total_pages: result.data.total_pages
        })
      );
    } else {
      console.error("[SEARCH] Result Error:", result);
      dispatch(_loadingSearch(false));
    }

    dispatch(_loadingSearch(false));
  } catch (error) {
    if (Axios.isCancel(error)) {
      console.info('[SEARCH_CUSTOMERS]: Previous request was cancelled!');
    } else {
      console.error(error);
      dispatch(_loadingSearch(false));
    }
  }
};

export const getStats = () => async (dispatch, getState) => {
  dispatch(_loadingStats(true));
  const searchStore = getState().search;
  const searchOptions = searchStore.searchOptions;

  try {
    const result = await DashboardApi.stats(searchOptions);

    if (result.success) {
      dispatch(_setStats(result.data));
    } else {
      // console.log("Stats Result: ", result);
      // let error_code = _.get(result, 'data.message.code');

      // console.log('STATS_RESULT: ', result);
      // if(error_code && error_code === "invalid_token" && login_error_count < 2) {
      //   await DashboardApi.login({
      //     email: "kareemgd@mitchdesigns.com",
      //     password: "123456"
      //   });
        
      //   return dispatch(getStats());
      // }
    }

    dispatch(_loadingStats(false));
  } catch (error) {
    if (Axios.isCancel(error)) {
      console.info('[GET_STATS]: Previous request was cancelled!');
    } else {
      console.error(error);
      dispatch(_loadingStats(false));
      dispatch(_searchError(error));
    }
  }
};

//Request to get chart data from backend
export const getChart = () => async (dispatch, getState) => {
  dispatch(_loadingChart(true));
  const searchStore = getState().search;
  const searchOptions = searchStore.searchOptions;
  console.log('Chart Search Option:',searchOptions);

  //don't make the chart request if the search request (CardID or Status)
  if(searchOptions.status !== undefined || searchOptions.variable !== undefined){
    console.log('status or variable:',searchOptions.status, searchOptions.variable )
    console.log('Ignore Chart request!');
    return;
  }
  
  try {
    const result = await DashboardApi.chartData(searchOptions);

    if (result.success) {
      dispatch(_setChart(result.data));
    } 
    dispatch(_loadingChart(false));

  } catch (error) {
    if (Axios.isCancel(error)) {
      console.info('[GET_CHART]: Previous request was cancelled!');
    } else {
      console.error(error);
      dispatch(_loadingChart(false));
      dispatch(_searchError(error));
    }
  }
}

export const setPerPage = (per_page) => dispatch => {
  dispatch(_setPerPage(per_page));
  dispatch(search({resetPage: true}));
}
export const setPage = (page) => dispatch => {
  dispatch(_setPage(page));
  dispatch(search());
}

export const setStatus = (status) => dispatch => dispatch(_setStatus(status));

export const setVariable = (variable) => dispatch => {
  clearTimeout(userInpTimerId);
  dispatch(_setVariable(variable));
  userInpTimerId = setTimeout(() => {
    dispatch(search({resetPage: true}));
    dispatch(getStats());
  }, timers.inputTrigger);
};
export const setDate = ({ from, to, range }) => (dispatch, getState) => {
  from = moment(from).startOf('day').format();
  to = moment(to).endOf('day').format();
  dispatch(_setDate({ from, to, range }));

  // update live tickets status
  dispatch(connectLiveTickets());

  // trigger search and get stats [TODO] - add chart
  dispatch(search({resetPage: true}));
  dispatch(getStats());
  dispatch(getChart());
}

export const setDateRange = (range) => dispatch => {
  let from, to = null;
  switch (range) {
    case "today":
      from = moment().startOf('day').format();
      to = moment().endOf('day').format();
      break;

    case "yesterday":
      from = moment().subtract(1, 'day').startOf('day').format();
      to = moment().subtract(1, 'day').endOf('day').format();
      break;

    case "last_7":
      from = moment().subtract(7, 'days').startOf('day').format();
      to = moment().subtract(1, 'days').endOf('day').format();
    break;

    case "last_30":
      from = moment().subtract(30, 'days').startOf('day').format();
      to = moment().subtract(1, 'days').endOf('day').format();
      break;

    case "this_month":
      from = moment().startOf('month').format();
      to = moment().endOf('day').format();
      break;

    case "last_month":
      from = moment().subtract(1, 'months').startOf('month').format();
      to = moment().subtract(1, 'months').endOf('month').format();
      break;

    case "last_2_months":
      from = moment().subtract(2, 'months').startOf('month').format();
      to = moment().subtract(1, 'months').endOf('month').format();
      break;

    case "last_3_months":
      from = moment().subtract(3, 'months').startOf('month').format();
      to = moment().subtract(1, 'months').endOf('month').format();
      break;

    default:
      from = moment().startOf('day').format();
      to = moment().endOf('day').format();
      break;
  }

  dispatch(setDate({from, to, range}));
}

/** Dispatchers */
function _loadingSearch(status) {
  return {
    type: A.loading_search,
    data: status
  };
}

function _loadingStats(status) {
  return {
    type: A.loading_stats,
    data: status
  };
}

function _loadingChart(status) {
  return {
    type: A.loading_chart,
    data: status
  };
}

function _setDate({ from, to, range }) {
  return {
    type: A.set_date,
    data: {
      from, to, range
    }
  };
}

function _setStatus(status) {
  return {
    type: A.set_status,
    data: status
  };
}

function _setVariable(variable) {
  return {
    type: A.set_variable,
    data: variable
  };
}

function _setPerPage(per_page) {
  return {
    type: A.set_per_page,
    data: per_page
  };
}

function _setPage(page) {
  return {
    type: A.set_page,
    data: page
  };
}

function _searchError(error) {
    return {
        type: A.search_error,
        data: error
    }
}
